// extracted by mini-css-extract-plugin
export default {"inputRoot":"style_inputRoot__+dis2"};